var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLindsayAdamsMediaAndDesignBrantOntarioLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "191px",
    height: "97px",
    viewBox: "0 0 191 97",
    style: {
      enableBackground: "new 0 0 191 97"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1F2022;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.1,1.3v94.5c0,0.3,0.2,0.5,0.5,0.5h94.5c0.3,0,0.5-0.2,0.5-0.5V1.3c0-0.3-0.2-0.5-0.5-0.5H1.6 C1.3,0.8,1.1,1,1.1,1.3z M27.7,69.3V28.6c0-0.4,0.5-0.6,0.8-0.3L69.3,69c0.3,0.3,0.1,0.8-0.3,0.8H28.2 C27.9,69.8,27.7,69.6,27.7,69.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.8,1.2h2.3V16h7.8v2.2h-10.1C105.8,18.2,105.8,1.2,105.8,1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.1,18.3c-0.4,0-0.8-0.2-1.1-0.5s-0.5-0.7-0.5-1.1s0.2-0.8,0.5-1.1s0.7-0.5,1.1-0.5s0.8,0.2,1.1,0.5 s0.5,0.7,0.5,1.1s-0.2,0.8-0.5,1.1S119.5,18.3,119.1,18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.6,1.2h2.1l7.3,17h-2.7l-1.7-4.2h-8.1l-1.7,4.2h-2.7L129.6,1.2L129.6,1.2L129.6,1.2z M133.8,12l-3.2-7.8 l0,0l-3.2,7.8H133.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.9,18.3c-0.4,0-0.8-0.2-1.1-0.5s-0.5-0.7-0.5-1.1s0.2-0.8,0.5-1.1s0.7-0.5,1.1-0.5s0.8,0.2,1.1,0.5 s0.5,0.7,0.5,1.1s-0.2,0.8-0.5,1.1S142.3,18.3,141.9,18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.7,27.2h3.4l5.4,12.9l0,0l5.4-12.9h3.4v17H121v-14l0,0l-5.7,14h-1.5l-5.7-14l0,0v14h-2.3v-17l0,0 L105.7,27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.3,27.2h11v2.2h-8.7v5.1h8.1v2.2h-8.1v5.4h9.1v2.2h-11.4v-17l0,0L127.3,27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.1,27.2h5.9c1.2,0,2.3,0,3.2,0.4c0.9,0.3,1.7,0.6,2.4,1.1s1.2,1,1.7,1.6c0.4,0.6,0.8,1.2,1,1.8 c0.2,0.6,0.4,1.2,0.6,1.9c0.1,0.6,0.2,1.2,0.2,1.7c0,1.1-0.2,2.1-0.6,3.2c-0.4,1-1,1.9-1.8,2.7s-1.8,1.4-2.9,1.9 c-1.2,0.5-2.5,0.7-4,0.7h-5.5v-17L141.1,27.2L141.1,27.2z M143.4,42h2.9c1,0,1.9,0,2.8-0.4c0.9-0.3,1.6-0.7,2.3-1.2s1.2-1.2,1.6-2 s0.6-1.7,0.6-2.8s0-1.2-0.3-1.9c-0.2-0.7-0.5-1.4-1-2.1c-0.5-0.7-1.2-1.2-2-1.7c-0.9-0.5-2-0.7-3.4-0.7h-3.5v12.7l0,0L143.4,42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.1,27.2h2.3v17h-2.3V27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.6,27.2h2.1l7.3,17h-2.7l-1.7-4.2h-8.1l-1.7,4.2h-2.7L170.6,27.2L170.6,27.2L170.6,27.2z M174.9,38 l-3.2-7.8l0,0l-3.2,7.8H174.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.2,53.2h2.1l7.3,17h-2.7l-1.7-4.2h-8.1l-1.7,4.2h-2.7L111.2,53.2L111.2,53.2L111.2,53.2z M115.3,64 l-3.2-7.8l0,0l-3.2,7.8C108.9,64,115.3,64,115.3,64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.4,53.2h3l9.4,14l0,0v-14h2.3v17h-2.9l-9.5-14l0,0v14h-2.3C122.4,70.2,122.4,53.2,122.4,53.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.8,53.2h5.9c1.2,0,2.3,0,3.2,0.4s1.7,0.6,2.4,1.1s1.2,1,1.7,1.6c0.4,0.6,0.8,1.2,1,1.8s0.4,1.2,0.6,1.9 c0.1,0.6,0.2,1.2,0.2,1.7c0,1.1-0.2,2.1-0.6,3.2c-0.4,1-1,1.9-1.8,2.7c-0.8,0.8-1.8,1.4-2.9,1.9c-1.2,0.5-2.5,0.7-4,0.7H141v-17 L140.8,53.2L140.8,53.2z M143.1,68h2.9c1,0,1.9,0,2.8-0.4c0.9-0.3,1.6-0.7,2.3-1.2s1.2-1.2,1.6-2s0.6-1.7,0.6-2.8s0-1.2-0.3-1.9 c-0.2-0.7-0.5-1.4-1-2.1s-1.2-1.2-2-1.7c-0.9-0.5-2-0.7-3.4-0.7h-3.5L143.1,68L143.1,68L143.1,68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.4,79.2h5.9c1.2,0,2.3,0,3.2,0.4c0.9,0.3,1.7,0.6,2.4,1.1s1.2,1,1.7,1.6c0.4,0.6,0.8,1.2,1,1.8 s0.4,1.2,0.6,1.9c0.1,0.6,0.2,1.2,0.2,1.7c0,1.1-0.2,2.1-0.6,3.2c-0.4,1-1,1.9-1.8,2.7c-0.8,0.8-1.8,1.4-2.9,1.9 c-1.2,0.5-2.5,0.7-4,0.7h-5.5v-17C105.6,79.2,105.4,79.2,105.4,79.2z M107.8,94h2.9c1,0,1.9,0,2.8-0.4s1.6-0.7,2.3-1.2 s1.2-1.2,1.6-2s0.6-1.7,0.6-2.8s0-1.2-0.3-1.9c-0.2-0.7-0.5-1.4-1-2.1s-1.2-1.2-2-1.7c-0.9-0.5-2-0.7-3.4-0.7h-3.5V94L107.8,94 L107.8,94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.3,79.2h11v2.2h-8.7v5.1h8.1v2.2h-8.1v5.4h9.1v2.2h-11.4L123.3,79.2L123.3,79.2L123.3,79.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.1,92.6c0.4,0.6,0.9,1.1,1.6,1.4c0.6,0.3,1.3,0.4,2,0.4s0.8,0,1.2-0.2c0.4,0,0.8-0.3,1.1-0.5 s0.6-0.5,0.8-0.9s0.3-0.8,0.3-1.2c0-0.7-0.2-1.2-0.6-1.5c-0.4-0.3-0.9-0.6-1.5-0.9c-0.6-0.2-1.3-0.5-2-0.7s-1.4-0.5-2-0.9 s-1.1-0.9-1.5-1.5s-0.6-1.5-0.6-2.6s0.1-1,0.3-1.6s0.6-1.1,1-1.5s1.1-0.9,1.8-1.2c0.7-0.3,1.6-0.5,2.6-0.5s1.8,0,2.7,0.4 c0.8,0.3,1.6,0.8,2.2,1.6l-1.9,1.7c-0.3-0.4-0.7-0.8-1.2-1.1c-0.5-0.3-1.1-0.4-1.8-0.4s-1.2,0-1.6,0.3s-0.8,0.4-1,0.6 c-0.3,0.3-0.4,0.5-0.5,0.9c-0.1,0.3-0.2,0.6-0.2,0.8c0,0.7,0.2,1.3,0.6,1.7c0.4,0.4,0.9,0.7,1.5,0.9s1.3,0.5,2,0.6 c0.7,0.2,1.4,0.5,2,0.8s1.1,0.8,1.5,1.4s0.6,1.4,0.6,2.4s-0.2,1.6-0.5,2.2c-0.3,0.7-0.7,1.2-1.3,1.7c-0.5,0.4-1.2,0.8-1.9,1 s-1.5,0.4-2.3,0.4s-2.1-0.2-3.1-0.6s-1.8-1-2.3-1.8L138.1,92.6L138.1,92.6L138.1,92.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.6,79.2h2.3v17h-2.3V79.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.4,86.7v8.4c-0.4,0.3-0.9,0.5-1.4,0.7s-1.1,0.4-1.6,0.5c-0.6,0-1.1,0.2-1.7,0.3h-1.6 c-1.4,0-2.7-0.2-3.9-0.7c-1.1-0.5-2.1-1.1-2.9-1.9c-0.8-0.8-1.4-1.8-1.8-2.8s-0.6-2.2-0.6-3.4s0.2-2.4,0.7-3.5c0.4-1.1,1-2,1.8-2.8 s1.7-1.4,2.8-1.9s2.3-0.7,3.6-0.7s2.8,0.2,3.8,0.6s1.8,0.9,2.5,1.6l-1.6,1.8c-0.7-0.7-1.4-1.1-2.2-1.4s-1.6-0.4-2.5-0.4 s-1.9,0.2-2.6,0.5c-0.8,0.4-1.5,0.8-2,1.5c-0.6,0.6-1,1.3-1.3,2.1c-0.3,0.8-0.5,1.7-0.5,2.6s0.2,1.9,0.5,2.7 c0.3,0.8,0.8,1.5,1.4,2.1s1.3,1.1,2.1,1.4s1.7,0.5,2.6,0.5s1.6,0,2.3-0.2s1.3-0.4,1.9-0.7v-4.7h-3.8v-2.2h6.1H171.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.3,79.2h3l9.4,14l0,0v-14h2.3v17h-2.9l-9.5-14l0,0v14h-2.3V79.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLindsayAdamsMediaAndDesignBrantOntarioLogo);
export default __webpack_public_path__ + "static/media/lindsay-adams-media-and-design-brant-ontario-logo.e47987362aa4c7808058517d12066876.svg";
export { ForwardRef as ReactComponent };